export default __webpack_public_path__ + "static/media/phone.566a735a.svg";